import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "petbond_pwa_dismissed_until";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosTip, setIosTip] = useState(false);

  useEffect(() => {
    try {
      const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (until && Date.now() < until) return;
    } catch {}
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;
    if (isIOS) { setIosTip(true); setShow(true); return; }
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };
  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + 7 * 24 * 3600 * 1000)); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:bottom-4 md:w-96 animate-in fade-in slide-in-from-bottom-4 duration-500" data-testid="pwa-install-prompt">
      <div className="bg-ink text-white rounded-2xl shadow-2xl border border-white/10 p-4 flex items-start gap-3">
        <img src="/brand/petbond-logo-192.png" alt="" className="w-12 h-12 object-contain shrink-0 rounded-xl"/>
        <div className="flex-1 min-w-0">
          <div className="font-extrabold text-sm">Install PetBond</div>
          {iosTip ? (
            <div className="text-xs text-white/70 mt-0.5 leading-snug">Tap <strong className="text-white">Share</strong> then <strong className="text-white">"Add to Home Screen"</strong> for the app experience.</div>
          ) : (
            <div className="text-xs text-white/70 mt-0.5">Faster access, works offline, no app store needed.</div>
          )}
          {!iosTip && (
            <button data-testid="pwa-install-btn" onClick={install} className="mt-2 bg-brand text-white rounded-full px-4 py-1.5 text-xs font-bold inline-flex items-center gap-1.5 hover:bg-brand-hover">
              <Download className="w-3.5 h-3.5"/> Install app
            </button>
          )}
        </div>
        <button data-testid="pwa-dismiss" onClick={dismiss} className="p-1 rounded-full hover:bg-white/10 shrink-0" aria-label="Dismiss"><X className="w-4 h-4"/></button>
      </div>
    </div>
  );
}
